"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeRangeFromIsoStrings = exports.formatTimeRange = exports.formatDateTimeFromIsoString = exports.formatDateTime = void 0;
var formatDateTime = function (_a) {
    var date = _a.date, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    dateOptions.timeZone = timeZone || 'UTC';
    return Intl.DateTimeFormat(locale, dateOptions).format(date);
};
exports.formatDateTime = formatDateTime;
var formatDateTimeFromIsoString = function (_a) {
    var isoString = _a.isoString, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    var date = new Date(isoString);
    return (0, exports.formatDateTime)({
        date: date,
        locale: locale,
        dateOptions: dateOptions,
        timeZone: timeZone,
    });
};
exports.formatDateTimeFromIsoString = formatDateTimeFromIsoString;
var formatTimeRange = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    var formattedStart = (0, exports.formatDateTime)({
        locale: locale,
        dateOptions: dateOptions,
        timeZone: timeZone,
        date: startTime,
    });
    var formattedEnd = (0, exports.formatDateTime)({
        locale: locale,
        dateOptions: dateOptions,
        timeZone: timeZone,
        date: endTime,
    });
    return formattedStart + " - " + formattedEnd;
};
exports.formatTimeRange = formatTimeRange;
var formatTimeRangeFromIsoStrings = function (_a) {
    var startTimeIsoString = _a.startTimeIsoString, endTimeIsoString = _a.endTimeIsoString, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    var startTime = new Date(startTimeIsoString);
    var endTime = new Date(endTimeIsoString);
    return (0, exports.formatTimeRange)({
        startTime: startTime,
        endTime: endTime,
        locale: locale,
        dateOptions: dateOptions,
        timeZone: timeZone,
    });
};
exports.formatTimeRangeFromIsoStrings = formatTimeRangeFromIsoStrings;
